import { z } from 'zod';

export const changePasswordSchema = z
  .object({
    currentPassword: z.string().min(1, 'validation.currentPasswordRequired'),
    password: z.string().min(8, 'validation.passwordLength'),
    confirmPassword: z.string().min(1, 'validation.confirmPassword'),
  })
  .refine((data) => data.currentPassword !== data.password, {
    message: 'validation.passwordMustDiffer',
    path: ['password'],
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: 'validation.passwordsMismatch',
    path: ['confirmPassword'],
  });

export type ChangePasswordFormValues = z.infer<typeof changePasswordSchema>;
